export var EvergreenCommunityListingSignupRequestSource;
(function (EvergreenCommunityListingSignupRequestSource) {
    EvergreenCommunityListingSignupRequestSource["AvailabilityRequestEmail"] = "AvailabilityRequestEmail";
    EvergreenCommunityListingSignupRequestSource["PricingRequestEmail"] = "PricingRequestEmail";
    EvergreenCommunityListingSignupRequestSource["ClientIntakeEmail"] = "ClientIntakeEmail";
    EvergreenCommunityListingSignupRequestSource["OutreachCampaign"] = "OutreachCampaign";
})(EvergreenCommunityListingSignupRequestSource || (EvergreenCommunityListingSignupRequestSource = {}));
export var EvergreenCommunityListingUpdateRequestSource;
(function (EvergreenCommunityListingUpdateRequestSource) {
    EvergreenCommunityListingUpdateRequestSource["AvailabilityRequestEmail"] = "AvailabilityRequestEmail";
})(EvergreenCommunityListingUpdateRequestSource || (EvergreenCommunityListingUpdateRequestSource = {}));
//# sourceMappingURL=types.js.map